import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IndianCurrencyFormatterComponent} from './indian-currency-formatter.component';

@NgModule({
    imports: [CommonModule],
    declarations: [IndianCurrencyFormatterComponent],
    exports: [IndianCurrencyFormatterComponent]
})
export class IndianCurrencyFormatterModule {
}
